var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLocaleAllowed && _vm.games.length,
          expression: "isLocaleAllowed && games.length"
        }
      ],
      staticClass: "section-listGame CategoryGames"
    },
    [
      _c("div", { staticClass: "section-listGame__header" }, [
        _c("div", { staticClass: "title" }, [
          _c("img", {
            ref: "image",
            attrs: { src: _vm.categoryImage, alt: _vm.categoryTitle }
          }),
          _c("div", { staticClass: "title__text" }, [
            _c("h2", { domProps: { textContent: _vm._s(_vm.categoryTitle) } }),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.categoryDescription) }
            })
          ])
        ]),
        _c(
          "div",
          { staticClass: "link" },
          [
            _c("router-link", { attrs: { to: _vm.categoryPageUrl } }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("front.game.button.see_all")) + " "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.totalGamesCount,
                        expression: "totalGamesCount"
                      }
                    ]
                  },
                  [_vm._v(_vm._s(_vm.totalGamesCount))]
                )
              ]),
              _c(
                "svg",
                {
                  attrs: {
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                  })
                ]
              )
            ])
          ],
          1
        )
      ]),
      _vm.componentName
        ? _c(_vm.componentName, {
            ref: "categoryGamesComponent",
            tag: "component",
            attrs: {
              items: _vm.games,
              "show-load-more-button": _vm.showLoadMoreButton,
              loadMoreDesktopRowsCount: _vm.loadMoreDesktopRowsCount,
              loadMoreMobileRowsCount: _vm.loadMoreMobileRowsCount,
              "total-items-count": _vm.totalGamesCount,
              "additional-game-rows-count": _vm.additionalGameRowsCount,
              "category-id": _vm.categoryId,
              "virtual-category-interface-id": _vm.virtualCategoryInterfaceId,
              "recommendation-id": _vm.vendorRecommendationId
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }